/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import DateLabel from '@atlaskit/date-label/date-label';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		display: 'flex',
		gap: token('space.100'),
		flexWrap: 'wrap',
		alignItems: 'center',
	},
});

export default function DateLabelSpacious(): React.JSX.Element {
	return (
		<div css={styles.wrapper}>
			<DateLabel label="29 Jul 2026" appearance="neutral" isSpacious />
			<DateLabel label="29 Jul 2026" appearance="warning" isSpacious />
			<DateLabel label="29 Jul 2026" appearance="danger" isSpacious />
		</div>
	);
}
